import { angleToHue } from '@/color/helpers/hueUtils';
export function isEqualHueRange(range1, range2) {
    const start1 = angleToHue(range1.start);
    const end1 = angleToHue(range1.end, 'end');
    const start2 = angleToHue(range2.start);
    const end2 = angleToHue(range2.end, 'end');
    return start1.hue === start2.hue && end1.hue === end2.hue;
}
export function isFullHueRange(range) {
    const startHue = angleToHue(range.start);
    const endHue = angleToHue(range.end);
    return startHue.hue === endHue.hue;
}
